<template :open="open">
  <div>
    <div
      class="flex cursor-pointer items-center gap-2 rounded-lg bg-white dark:bg-neutral-800 p-4 text-lg font-semibold leading-6 shadow-[0_0_2px_rgba(0,0,0,.1)]"
      @click="toggle()"
    >
      <UiIcon icon="stack" :size="20" />
      <span class="grow">
        <slot name="title">{{ title }}</slot>
      </span>
      <UiIcon icon="chevron-down" :size="20" class="transition-transform" :class="{ '-rotate-180': open }" />
    </div>
    <transition
      enter-active-class="transition ease-out duration-300 transform"
      enter-from-class="opacity-0 -translate-y-4"
      enter-to-class="opacity-100 translate-y-0"
      leave-active-class="transition ease-out duration-300 transform"
      leave-from-class="opacity-100 translate-y-0"
      leave-to-class="opacity-0 -translate-y-4"
    >
      <div v-show="open" class="mt-4">
        <slot :open="open" />
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import UiIcon from '@/components/ui/icon.vue'

defineProps<{
  title?: string
}>()
const open = ref(false)

const toggle = () => (open.value = !open.value)
</script>
